export default {
  'config-tracking': ['add', 'edit', 'delete'],
  'config-organizations': {
    subitem1: ['add', 'edit', 'delete'],
    subitem2: ['add', 'edit', 'delete'],
    subitem3: ['add', 'edit', 'delete']
  }
}